module.exports = {
  'en': {
    'HRMS14X': {
      '10': 'Inquire/Print List of New Hired/Resigned',
      '20': 'Department Code',
      '30': 'In Month',
      '31': 'null',
      '40': 'Year',
      '50': 'Type of Data',
      '60': 'New Hired',
      '70': 'Resigned',
      '71': 'Salary',
      '72': 'Other Incom',
      '80': 'Department Name',
      '90': 'Seq. No.',
      '100': 'Emp. Code',
      '110': 'Emp. Name',
      '120': 'Department',
      '130': 'Position',
      '140': 'Job Level',
      '150': 'Hired Date',
      '160': 'Resign Date'
    },
    'HRMS14XC1': {
      '10': 'Type of function',
      '20': 'Request Date From',
      '30': 'To',
      '40': 'For Department',
      '50': 'Or Emp.',
      '60': 'Status',
      '70': 'Seq.',
      '80': 'Emp.Code',
      '90': 'Employee name',
      '100': 'Request Date',
      '110': 'Seq. No.',
      '120': 'Status',
      '130': 'Route No.',
      '140': 'Approved By',
      '150': 'Approved Date',
      '160': 'Remark',
      '165': 'Next Approver',
      '170': 'All',
      '910': 'Employee Name',
      '920': 'Personal Data',
      '930': 'Education Data',
      '940': 'Children Data',
      '950': 'Honour "s',
      '960': 'Training Record'
    },
    'HRMS14XC2': {
      '10': 'show approval each step detail',
      '20': 'Type of function',
      '30': 'For Employee',
      '40': 'Route No',
      '50': 'Req. Date',
      '60': 'Approve Status',
      '70': 'Seq. No.',
      '80': 'Approved By',
      '90': 'Send mail  Date',
      '100': 'Approved Date',
      '110': 'approved next',
      '120': 'Approve Status',
      '130': 'Approved Remark',
      '140': 'หัวหน้างาน',
      '150': 'หัวหน้าตามโครงสร้างสายงาน',
      '160': 'หน่วยงาน - ตำแหน่ง',
      '170': 'Employee Name'
    },
    'HRMS14XC3': {
      '10': 'Edit approval each step detail',
      '20': 'Type of function',
      '30': 'For Employee',
      '40': 'Route No',
      '50': 'Req. Date',
      '60': 'Approve Status',
      '70': 'Seq. No.',
      '80': 'Approved By',
      '90': 'Seq. No.',
      '100': 'Department',
      '110': 'Position',
      '120': 'Emp. Code',
      '130': 'Emp. Name'
    },
    'HRMS14XC4': {
      '10': 'show approval each step detail',
      '20': 'For Employee',
      '30': 'Route No.',
      '40': 'Seq. No',
      '50': 'Approved By',
      '60': 'Approved by',
      '70': 'Approved Name',
      '80': 'Department',
      '90': 'Position',
      '100': 'Seq. No.',
      '110': 'Approved by',
      '120': 'Approved Name',
      '130': 'Status',
      '910': 'Supervisor',
      '920': 'By Organization',
      '930': 'Position And Department',
      '940': 'Emp. Code',
      '950': 'By Flow',
      '960': 'Authorized representatives',
      '970': 'Assign'
    }
  },
  'th': {
    'HRMS14X': {
      '10': 'สอบถาม/พิมพ์ รายชื่อพนักงานเข้า/ออก',
      '20': 'รหัสหน่วยงาน',
      '30': 'ระหว่างเดือน',
      '31': 'ถึงเดือน',
      '40': 'ปี',
      '50': 'ประเภทข้อมูล',
      '60': 'พนง.ใหม่',
      '70': 'ลาออก',
      '71': 'เงินเดือน',
      '72': 'เงินได้ประจำอื่นๆ',
      '80': 'ชื่อหน่วยงาน',
      '90': 'ลำดับที่',
      '100': 'รหัสพนักงาน',
      '110': 'ชื่อ-นามสกุล',
      '120': 'หน่วยงาน',
      '130': 'ตำแหน่ง',
      '140': 'ระดับพนักงาน',
      '150': 'วันที่เข้างาน',
      '160': 'วันที่พ้นสภาพ'
    },
    'HRMS14XC1': {
      '10': 'ประเภทเรื่อง',
      '20': 'วันที่ยื่นคำร้อง ตั้งแต่',
      '30': 'ถึง',
      '40': 'สำหรับหน่วยงาน',
      '50': 'หรือ รหัสพนักงาน',
      '60': 'สถานะ',
      '70': 'ลำดับที่',
      '80': 'รหัสพนักงาน',
      '90': 'ชื่อ-สกุล',
      '100': 'วันที่บันทึก',
      '110': 'ลำดับที่บันทึก',
      '120': 'สถานะ',
      '130': 'Route No.',
      '140': 'ผู้อนุมัติล่าสุด',
      '150': 'วันที่อนุมัติ',
      '160': 'หมายเหตุ',
      '165': 'ผู้อนุมัติลำดับถัดไป',
      '170': 'ทั้งหมด',
      '910': 'ชื่อพนักงาน',
      '920': 'ข้อมูลส่วนตัว',
      '930': 'ข้อมูลการศึกษา',
      '940': 'ข้อมูลบุตร',
      '950': 'ข้อมูลคุณความดี',
      '960': 'ข้อมูลการฝึกอบรม'
    },
    'HRMS14XC2': {
      '10': 'แสดงรายละเอียดการอนุมัติแต่ละขั้นตอน',
      '20': 'ประเภทเรื่อง',
      '30': 'สำหรับพนักงาน',
      '40': 'Route No',
      '50': 'วันที่บันทึก',
      '60': 'สถานะการอนุมัติ',
      '70': 'ลำดับที่',
      '80': 'อนุมัติโดย',
      '90': 'วันที่ส่ง Mail',
      '100': 'วันที่อนุมัติ',
      '110': 'ผู้อนุมัติ',
      '120': 'สถานะการอนุมัติ',
      '130': 'หมายเหตุการอนุมัติ',
      '140': 'หัวหน้างาน',
      '150': 'หัวหน้าตามโครงสร้างสายงาน',
      '160': 'หน่วยงาน - ตำแหน่ง',
      '170': 'พนักงาน'
    },
    'HRMS14XC3': {
      '10': 'แก้ไขรายละเอียดการอนุมัติแต่ละขั้นตอน',
      '20': 'ประเภทเรื่อง',
      '30': 'สำหรับพนักงาน',
      '40': 'Route No',
      '50': 'วันที่บันทึก',
      '60': 'สถานะการอนุมัติ',
      '70': 'ลำดับที่อนุมัติ',
      '80': 'อนุมัติโดย',
      '90': 'ลำดับที่',
      '100': 'หน่วยงานผู้อนุมัติ',
      '110': 'ตำแหน่งผู้อนุมัติ',
      '120': 'รหัสผู้อนุมัติ',
      '130': 'ชื่อ - นามสกุล'
    },
    'HRMS14XC4': {
      '10': 'แสดงรายละเอียดการอนุมัติตาม Route No.',
      '20': 'สำหรับพนักงาน',
      '30': 'Route No.',
      '40': 'ลำดับที่อนุมัติ',
      '50': 'อนุมัติโดย',
      '60': 'รหัสผู้อนุมัติ',
      '70': 'ชื่อ',
      '80': 'หน่วยงาน',
      '90': 'ตำแหน่ง',
      '100': 'ลำดับที่',
      '110': 'รหัสผู้อนุมัติ',
      '120': 'ชื่อ',
      '130': 'สถานะ',
      '910': 'หัวหน้างาน',
      '920': 'ตามโครงสร้างสายงาน',
      '930': 'หน่วยงานและตำแหน่ง',
      '940': 'รหัสพนักงาน',
      '950': 'ตาม Flow',
      '960': 'อนุมัติแทน',
      '970': 'Assign'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hrms14x.js